import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeftFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutLeftFull"><Path d="M3 21V3H9V21L3 21Z" fill="currentColor"/><Path d="M11 21L21 21V3H11V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeftFull;
